import { configureStore } from "@reduxjs/toolkit";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage"; // default storage
import authReducer from "./authSlice"; 
import cartReducer from "./cartSlice";
import adminReducer from "./AdminSlice";
import productReducer from "./productSlice"
import { combineReducers } from "redux";  // Import combineReducers

// Persist config for root state
const persistConfig = {
  key: "root",  // key for the persisted state
  storage,      // default storage (localStorage/sessionStorage)
};

// Combine the reducers into a single rootReducer
const rootReducer = combineReducers({
  auth: authReducer,
  cart: cartReducer,
  admin: adminReducer,
  product: productReducer,
});

// Apply persistReducer to the combined reducers
const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['auth/loginSuccess'],
        ignoredPaths: ['auth.user.proactiveRefresh'],
      },
    }),
});

// Create the persistor for redux-persist
const persistor = persistStore(store);

export { store, persistor };  // Export store and persistor
